<template>
    <div>

        <div class="header bottom">

        </div>

        <el-steps :active="2" align-center class="steps">
            <el-step title="验证手机号"></el-step>
            <el-step title="填写账号信息"></el-step>
            <el-step title="注册成功" status="wait"></el-step>
        </el-steps>

        <div>
            <el-form :model="form" class="form">

                <el-form-item>
                    <el-input v-model="form.userId" placeholder="请输入用户名"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-input v-model="form.password1" placeholder="请输入密码"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-input v-model="form.password2" placeholder="请再次输入密码"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="submitForm" class="submit-btn">立即注册</el-button>
                </el-form-item>

            </el-form>
        </div>

        <div class="divider"></div>
        <div class="footer">
            Copyright © 2012-2018  256.com  版权所有  沪ICP备11041704号-31  京ICP证070359号
        </div>
    </div>
</template>

<script>
    export default {
        name: "register_step_1",
        data(){
            return {
                labelPosition:"0",
                form:{
                    userId:"",
                    password1:"",
                    password2:"",
                }
            }
        },
        methods:{
            submitForm(){

            }
        }
    }
</script>

<style scoped>

    .header{
        width: 100%;
        height: 110px;
    }

    .steps{
        width: 400px;
        margin: 100px auto;
    }

    .form{
        width: 400px;
        margin: 80px auto 0;
    }

    .submit-btn{
        width: 100%;
    }

    .bottom {
        border-bottom: 1px solid rgb(230,230,230);
    }

    .divider{
        margin: 150px auto 10px;
        width: 80%;
        height: 1px;
        background-color: rgb(230,230,230);
    }

    .footer{
        font-size: 12px;
        color: #999;
    }
</style>